export default __webpack_public_path__ + "static/media/1971.ca8e2f50.png";